import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/GlobalStore';

const defaultTimeoutMilliseconds = 5000;

const SlideShow = (props: { switchComponent: () => void; loop: boolean }) => {
  const veille = useSelector((state: RootState) => state.BotConfig.veille);
  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (veille?.slideShow?.sources && veille.slideShow.sources.length > 0) {
      timerRef.current = setTimeout(() => {
        currentIndex === (veille.slideShow!.sources.length - 1)
          ? props.loop
            ? setCurrentIndex(0)
            : props.switchComponent()
          : setCurrentIndex(currentIndex + 1);
      }, veille.slideShow.timeBeforeSwitch
        ? veille.slideShow.timeBeforeSwitch * 1000
        : defaultTimeoutMilliseconds);
    } else {
      props.switchComponent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#000' }}>
      <img
        style={window.innerHeight > window.innerWidth ? { width: '100%' } : { height: '100%' }}
        src={veille?.slideShow?.sources[currentIndex] || ''}
        alt="slideshow"
      />
    </div>
  );
};

export default SlideShow;
